var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      attrs: {
        label: _vm.$t.__(
          "dashboard.forms.FiscalYearsSelect.select_starting_tax_year"
        ),
        prop: "fiscal"
      }
    },
    [
      _c(
        "el-select",
        {
          staticClass: "wp-1",
          on: { change: _vm.updateFiscalYears },
          model: {
            value: _vm.item,
            callback: function($$v) {
              _vm.item = $$v
            },
            expression: "item"
          }
        },
        _vm._l(_vm.fiscalList, function(fiscal) {
          return _c("el-option", {
            key: fiscal.label,
            attrs: {
              label: fiscal.label,
              value: fiscal.value,
              disabled: fiscal.disabled
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }